import type { Theme } from '@mui/material';

import { muiSelectStyles } from 'src/theme/sharedStyles';

export const styles = {
  stack: (theme: Theme) => ({
    gap: '0.75rem',
    flexDirection: 'column',
    borderBottom: `1px solid ${theme.colors.neutral[100]}`,
    pb: 1.5,

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  }),
  insightWheelSearch: (theme: Theme) => ({
    flex: 2,
    color: theme.colors.neutral[500],
  }),

  insightWheelDropdown: muiSelectStyles.filterSelect,

  insightWheelDropdownItem: muiSelectStyles.filterMenuItem,

  menuProps: muiSelectStyles.filterPaper,
};
